export const filter_config = (event_options = []) => ({
  title: 'Workflow filters',
  filters: [
    {
      label: 'Conversion event',
      value: event_options,
      key: 'conversion_event',
      type: 'multichoice'
    },
    { value: 'created_on', label: 'Date created', key: 'created_on', type: 'range' }
  ]
});
